import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { PatientContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import Form from "react-bootstrap/Form";
import { Row, Col } from "react-bootstrap";

import Sallie from "../Sallie";
import OnboardingStepHeader from "./OnboardingStepHeader";
import SubmitButton from "../StyledComponents/SubmitButton";
import NotificationSchema from "./validations/notificationSchema";

import { postTrackingPrefs } from "../../api/TBIRequests";
import { sendPatientFinishedOnboardingEmail } from "../../api/helpReq";

import { format } from "date-fns";
import TimeInput from "../TimeInput";
import stringifyDayOfWeek from "../../lib/stringifyDayOfWeek";
import customizeMessages from "../../lib/customizeMessages";

const NotificationPrefs = ({ user, setOnboardingPercent }) => {
    const { patient } = useContext(PatientContext);
    const { t } = useTranslation();
    const [timezone, setTimezone] = useState("America/New_York");
    const history = useHistory();

    useEffect(() => {
        setOnboardingPercent(80);
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        setTimezone(tz || "America/New_York");
    }, []);

    const {
        register,
        handleSubmit,
        errors,
        watch,
        formState: { isSubmitting },
    } = useForm({
        defaultValues: {
            emailAlert: true,
            textAlert: true,
            //smsConsent: false,
            hour: "04",
            partOfDay: "PM",
            monday: true,
            tuesday: true,
            wednesday: true,
            thursday: true,
            friday: true,
            saturday: true,
            sunday: true,
        },
        resolver: yupResolver(NotificationSchema),
    });

    const emailAlert = watch("emailAlert");
    const textAlert = watch("textAlert");
    const isAnyAlert = !!(emailAlert || textAlert);

    const onSubmit = async (data) => {
        const saveNotificationPreferences = async () => {
            const timeAlert = isAnyAlert
                ? format(
                      new Date(
                          0,
                          0,
                          0,
                          data.partOfDay === "AM" ? data.hour : data.hour + 12,
                          0
                      ),
                      "HH:mm"
                  )
                : null;

            const notificationData = {
                textAlert: !!data.textAlert,
                emailAlert: !!data.emailAlert,
                timeAlert,
                dayOfWeek: stringifyDayOfWeek(data),
                tz: timezone,
                patientId: patient.patientId,
                //smsConsent: !!data.smsConsent,
            };

            await postTrackingPrefs({ data: notificationData });
        };

        const sendFinishedOnboardingEmail = async () => {
            console.log("user object: ", user );

            const emailData = {
                userEmail: user.email,
                firstName: patient.firstName,
                lastName: patient.lastName,
                clinic_location: user.clinic_location,   // patient.clinic_location, 
                clinic_name: user.clinic_name,   // patient.clinic_name
            };

            await sendPatientFinishedOnboardingEmail({ data: emailData });
        };

        try {
            await saveNotificationPreferences();
            await sendFinishedOnboardingEmail();
            history.push("/Verification/EmailSent");
        } catch (err) {
            console.error("Step 5 Error:", err);
            history.push("/oops");
        }
    };

    const getPossibleMessages = () => ({
        mainHeader: {
            Stroke: t("onboarding.notifPrefs.header"),
            tbiPatient: t("onboarding.notifPrefs.header"),
            caregiver: t("onboarding.notifPrefs.header"),
        },
        sallieText: {
            Stroke: t("onboarding.notifPrefs.sallie"),
            tbiPatient: t("onboarding.notifPrefs.sallie"),
            caregiver: t("onboarding.notifPrefs.sallie"),
        },
    });

    const getMessage = customizeMessages({ getPossibleMessages, user });

    return (
        <>
            <OnboardingStepHeader text={getMessage("mainHeader")} />
            <Sallie text={getMessage("sallieText")} />
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Label
                    as="h6"
                    style={{ width: "100%", margin: "10px 0px 20px 0px" }}
                >
                    {t("onboarding.notifPrefs.dashboard")}
                </Form.Label>
                <Row className="mb-3" style={{ padding: "0 8px" }}>
                    {/*<Col xs={2}>
                        <Form.Check
                            name="textAlert"
                            ref={register}
                            type="checkbox"
                            label={t("onboarding.text")}
                        />
                    </Col>*/}
                    <Col>
                        <Form.Check
                            name="emailAlert"
                            ref={register}
                            type="checkbox"
                            label={t("basicInfo.email")}
                        />
                    </Col>
                </Row>

                <TimeInput
                    errors={errors}
                    register={register}
                    label={t("onboarding.notifPrefs.dayOfWeek.label")}
                    disableStatus={!isAnyAlert}
                />

                {/* <Form.Check
                    name="smsConsent"
                    ref={register}
                    type="checkbox"
                    label={t("onboarding.notifPrefs.smsConsent")}
                    disabled={!textAlert}
                />
                {errors.smsConsent && (
                    <Form.Control.Feedback
                        type="invalid"
                        style={{ display: "block", marginBottom: "1rem" }}
                    >
                        {errors.smsConsent.message}
                    </Form.Control.Feedback>
                )} */}

                <SubmitButton disabled={isSubmitting} type="submit">
                    {t("onboarding.saveContinue")} &gt;
                </SubmitButton>
            </Form>
        </>
    );
};
export default NotificationPrefs;